import { CircularProgress } from 'library/loaders';
import useLoadingText from 'modules/shared/hooks/useLoadingText';

const PageLoader = () => {
    const { text } = useLoadingText({
        messages: ['Getting everything ready...', 'Putting everything together...', 'Almost there...'],
        delay: 3000,
    });

    return (
        <div className="fixed top-0 left-0 flex flex-col items-center justify-center h-screen w-full bg-card-color">
            <div className="flex items-center justify-center w-14 h-14 rounded-lg text-white bg-primary">
                <CircularProgress size={32} />
            </div>
            <div className="font-semibold mt-6">{text}</div>
        </div>
    );
};

export default PageLoader;
